// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PurchaseOrderLine } from './purchase-order-line';
import { PurchaseOrderPickUp } from './purchase-order-pick-up';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PurchaseOrderPickUpLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // used on vendor pickup
  quantityScheduled: number;
  quantityReadyToPickUp: number;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  completed?: Date;
  completedBy?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  notes?: string;
  purchaseOrderLineId!: number;
  purchaseOrderPickUpId!: number;
  quantity!: number;
  purchaseOrderLine!: PurchaseOrderLine;
  purchaseOrderPickUp!: PurchaseOrderPickUp;
}

